import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'public_school_district_of_residence',
    title: 'Public school district of residence',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'school_district_number',
    title: 'School district number',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{4}$',
      },
    ],
  },
];

export const exemptionReasonQ = [
  {
    id: 'exempt_reason',
    title: 'I am not subject to Ohio or school district income tax withholding because (check all that apply):',
    question_type: 'long_multiple_selection',
    options: [
      {
        codeValue: 'resident_other_state',
        shortName: 'I am a full-year resident of Indiana, Kentucky, Michigan, Pennsylvania, or West Virginia.',
      },
      {
        codeValue: 'resident_military',
        shortName: 'I am a resident military servicemember who is stationed outside Ohio on active duty military orders.',
      },
      {
        codeValue: 'nonresident_military',
        shortName: 'I am a nonresident military servicemember who is stationed in Ohio due to military orders.',
      },
      {
        codeValue: 'military_spouse',
        shortName:
         'I am a nonresident civilian spouse of a military servicemember and I am present in Ohio solely due to my spouse’s military orders.',
      },
      {
        codeValue: 'exempt_rc5747',
        shortName: 'I am exempt from Ohio withholding under R.C. 5747.06(A)(1) through (6).',
      },
    ],
  },
];

export const exemptionQ3 = [
  {
    id: 'dependents',
    title: 'How many dependents are you claiming? (Line 3)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
];

export const exemptionQ4 = [
  {
    id: 'additional_withholding',
    title: 'Additional Ohio income tax withholding per pay period (Line 5)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
